<template>
  <div>
    <v-card elevation="0">
      <v-card-title class="d-flex justify-space-between align-center">
        <h2>Campos personalizados</h2>
        <v-btn color="primary" @click="openCreateDialog">
          <v-icon left>mdi-plus</v-icon>
          Nuevo campo
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item
            v-for="customField in customFields"
            :key="customField._id"
            class="mb-2"
          >
            <v-list-item-content>
              <v-list-item-title class="text-h6">
                {{ customField.label }}
                <v-chip
                  small
                  :color="customField.required ? 'error' : 'grey'"
                  class="ml-2"
                >
                  {{ customField.required ? "Requerido" : "Opcional" }}
                </v-chip>
                <v-chip
                  small
                  :color="customField.disabled ? 'grey' : 'success'"
                  class="ml-2"
                >
                  {{ customField.disabled ? "Deshabilitado" : "Habilitado" }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle>
                <div class="mt-2">
                  <strong>Clave:</strong> {{ customField.key }}
                </div>
                <div class="mt-1">
                  <strong>Tipo:</strong> {{ customField.type }}
                </div>
                <div v-if="customField.description" class="mt-1">
                  <strong>Descripción:</strong> {{ customField.description }}
                </div>
                <div
                  v-if="customField.options && customField.options.length"
                  class="mt-1"
                >
                  <strong>Opciones:</strong>
                  <v-chip
                    v-for="option in customField.options"
                    :key="option"
                    small
                    class="ml-1"
                  >
                    {{ option }}
                  </v-chip>
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="handleEdit(customField)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon @click="handleDelete(customField)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>

    <!-- Diálogo de creación/edición -->
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>
          {{
            isEdit ? "Editar campo personalizado" : "Nuevo campo personalizado"
          }}
        </v-card-title>
        <v-card-text>
          <custom-field-form
            ref="form"
            :initial-data="selectedField"
            :is-edit="isEdit"
            @update:formData="handleFormUpdate"
            @update:isValid="handleFormValidation"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">Cancelar</v-btn>
          <v-btn color="primary" :disabled="!isFormValid" @click="handleSubmit">
            {{ isEdit ? "Guardar" : "Crear" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  getCustomFields,
  createCustomField,
  updateCustomField,
  deleteCustomField
} from "@/api/mntto/customFields-api";
import CustomFieldForm from "./CustomFieldForm.vue";

export default {
  name: "CustomFields",
  components: {
    CustomFieldForm
  },
  props: {
    realEstateGroupId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      customFields: [],
      dialog: false,
      isEdit: false,
      isFormValid: false,
      selectedField: null,
      formData: null
    };
  },
  methods: {
    async loadCustomFields() {
      try {
        const response = await getCustomFields(this.realEstateGroupId);
        this.customFields = response.data;
      } catch (error) {
        this.$snotify.error("Error al cargar los campos personalizados");
      }
    },
    openCreateDialog() {
      this.isEdit = false;
      this.selectedField = {
        key: "",
        label: "",
        description: "",
        type: "string",
        options: [],
        required: false,
        disabled: false
      };
      this.dialog = true;
    },
    handleEdit(field) {
      this.isEdit = true;
      this.selectedField = { ...field };
      this.dialog = true;
    },
    handleDelete(field) {
      this.$confirmation(
        "Eliminar campo",
        "¿Estás seguro de eliminar este campo?",
        () => this.deleteField(field)
      );
    },
    async deleteField(field) {
      try {
        await deleteCustomField(this.realEstateGroupId, field.key);
        await this.loadCustomFields();
        this.$snotify.success("Campo eliminado correctamente");
      } catch (error) {
        this.$snotify.error("Error al eliminar el campo");
      }
    },
    handleFormUpdate(data) {
      this.formData = data;
    },
    handleFormValidation(isValid) {
      this.isFormValid = isValid;
    },
    async handleSubmit() {
      if (!this.$refs.form.validate()) {
        this.$snotify.error("Por favor, complete todos los campos requeridos");
        return;
      }

      try {
        if (this.isEdit) {
          await updateCustomField(
            this.realEstateGroupId,
            this.formData.key,
            this.formData
          );
          this.$snotify.success("Campo actualizado correctamente");
        } else {
          await createCustomField(this.realEstateGroupId, this.formData);
          this.$snotify.success("Campo creado correctamente");
        }
        await this.loadCustomFields();
        this.closeDialog();
      } catch (error) {
        this.$snotify.error("Error al guardar el campo");
      }
    },
    closeDialog() {
      this.dialog = false;
      this.selectedField = null;
      this.formData = null;
      this.isFormValid = false;
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    }
  },
  async mounted() {
    await this.loadCustomFields();
  }
};
</script>

<style scoped>
.v-list-item {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
</style>
